{
  "booking": {
    "title": "Bookings",
    "description": "Manage and confirm bookings. Confirmed bookings will appear in the calendar below.",
    "stats": {
      "totalBookings": "Total Bookings",
      "pending": "Pending",
      "confirmed": "Confirmed",
      "upcomingToday": "Upcoming Today"
    },
    "table": {
      "booking": "Booking",
      "customer": "Customer",
      "resource": "Resource",
      "dateTime": "Date & Time",
      "status": "Status",
      "actions": "Actions",
      "party": "Party: {{size}}"
    },
    "actions": {
      "confirmBooking": "Confirm Booking",
      "confirm": "Confirm",
      "rescheduleWithAI": "Reschedule with AI Agent",
      "aiReschedule": "AI Reschedule",
      "cancelBooking": "Cancel Booking",
      "cancel": "Cancel"
    },
    "unconfirmed": {
      "title": "Unconfirmed Bookings",
      "searchPlaceholder": "Search bookings...",
      "filterPending": "Pending",
      "filterAll": "All",
      "pagination": "{{start}}-{{end}} of {{total}} bookings"
    },
    "calendar": {
      "title": "Confirmed Bookings Calendar",
      "hint": "Click on a booking to view details"
    },
    "details": {
      "title": "Booking Details",
      "description": "Description:",
      "customer": "Customer:",
      "dateTime": "Date & Time:"
    },
    "messages": {
      "confirmSuccess": "Booking confirmed successfully!",
      "confirmError": "Failed to confirm booking",
      "cancelTitle": "Cancel Booking",
      "cancelContent": "Are you sure you want to cancel this booking?",
      "cancelOk": "Yes, Cancel",
      "cancelNo": "No",
      "cancelSuccess": "Booking cancelled successfully!",
      "cancelError": "Failed to cancel booking"
    }
  },
  "calendar": {
    "messages": {
      "confirmTitle": "Confirm Appointment",
      "confirmContent": "Are you sure you want to confirm this appointment{{name}} on {{date}}?",
      "confirmOk": "Yes, Confirm",
      "confirmSuccess": "Appointment confirmed successfully",
      "confirmError": "Failed to confirm appointment",
      "cancelTitle": "Cancel Appointment",
      "cancelContent": "Are you sure you want to cancel this appointment{{name}} on {{date}}?",
      "cancelOk": "Yes, Cancel",
      "cancelSuccess": "Appointment cancelled successfully",
      "cancelError": "Failed to cancel appointment",
      "deleteTitle": "Delete Appointment",
      "deleteContent": "Are you sure you want to delete this appointment{{name}} on {{date}}? This action cannot be undone.",
      "deleteOk": "Yes, Delete",
      "deleteSuccess": "Appointment deleted successfully",
      "deleteError": "Failed to delete appointment",
      "noShowTitle": "Mark as No Show",
      "noShowContent": "Mark this appointment{{name}} on {{date}} as a customer no-show?",
      "noShowOk": "Yes, Mark No Show",
      "noShowSuccess": "Appointment marked as no show",
      "noShowError": "Failed to mark appointment as no show",
      "withClient": " with {{name}}"
    }
  },
  "appointmentComponents": {
    "calendarHeader": {
      "title": "Calendar",
      "description": "View and manage your appointments and bookings.",
      "createAppointment": "Add Appointment"
    },
    "stats": {
      "totalAppointments": "Total Appointments",
      "scheduled": "Scheduled",
      "confirmed": "Confirmed",
      "upcomingToday": "Upcoming Today"
    },
    "filters": {
      "title": "Filters",
      "status": "Status",
      "allStatuses": "All Statuses",
      "user": "User",
      "allUsers": "All Users",
      "resource": "Resource",
      "allResources": "All Resources",
      "clearFilters": "Clear Filters",
      "actions": "Actions",
      "apptCount": "{{count}} appt",
      "apptCount_plural": "{{count}} appts",
      "showExternalCalendars": "Show external calendars",
      "loadingExternalEvents": "Loading external calendar events…",
      "noResources": "No resources available. Add a resource to view the calendar.",
      "statusLabels": {
        "SCHEDULED": "Scheduled",
        "CONFIRMED": "Confirmed",
        "PENDING": "Pending",
        "IN_PROGRESS": "In progress",
        "CANCELLED": "Cancelled",
        "COMPLETED": "Completed",
        "NO_SHOW": "No-show",
        "SHADOW": "Shadow"
      }
    },
    "calendar": {
      "appointment": {
        "hiddenSuffix": "· hidden",
        "clientPending": "pending",
        "fallbackTitle": "Appointment"
      }
    },
    "externalEvent": {
      "notAvailable": "n/a",
      "unavailable": "unavailable",
      "readOnly": "Imported calendar event (read only)",
      "details": {
        "title": "External calendar event",
        "summary": "Title",
        "location": "Location",
        "resource": "Resource",
        "dateTime": "Date & time",
        "ends": "Ends at {{time}}",
        "readOnly": "Imported (read only)",
        "noSummary": "No title"
      }
    },
    "conflictAlert": {
      "title": "Scheduling conflict detected",
      "description": "An external calendar event ({{externalLabel}}, {{timeRange}}) overlaps with an existing SA appointment ({{appointmentName}}) on {{weekday}}, {{date}}. The existing appointment has not been cancelled — manual resolution is required.",
      "summary": "{{count}} scheduling conflicts detected between imported calendar events and SA appointments:",
      "item": "{{externalLabel}} ({{timeRange}}) overlaps {{appointmentName}} on {{weekday}}, {{date}}.",
      "footer": "The existing appointments have not been cancelled — manual resolution is required."
    },
    "conflictDayBadge": "Conflict",
    "legend": {
      "title": "Status Legend:",
      "scheduled": "Scheduled (Unconfirmed)",
      "confirmed": "Confirmed",
      "pending": "Pending",
      "inProgress": "In Progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "noShow": "No Show",
      "externalBlocked": "External / Blocked"
    },
    "jumpToDate": "Jump to date:",
    "addAppointmentOnDay": "Add Appointment",
    "resourceFallback": "Resource {{id}}",
    "changeRequest": {
      "pendingPanelEmpty": "No pending customer change requests",
      "pendingHeaderButton": "Pending requests",
      "pendingDrawerTitle": "Pending change requests",
      "review": "Review",
      "reviewTitle": "Review change request",
      "customer": "Customer",
      "requestType": "Request type",
      "typeReschedule": "Reschedule appointment",
      "status": "Status",
      "originalTime": "Original appointment",
      "requestedTime": "Requested time",
      "customerNote": "Customer note",
      "internalRejectNote": "Internal rejection note",
      "internalRejectNoteHint": "Visible to tenant staff only",
      "approve": "Approve",
      "reject": "Reject",
      "approvedSuccess": "Change request approved.",
      "rejectedSuccess": "Change request rejected.",
      "approveFailed": "Could not approve the change request.",
      "rejectFailed": "Could not reject the change request.",
      "alreadyResolved": "This request has already been processed.",
      "submittedAgo": "Submitted {{time}}",
      "statusApproved": "Approved",
      "statusRejected": "Rejected",
      "appointment": "Appointment",
      "internalRejectNotePlaceholder": "Reason for rejecting (optional)"
    },
    "details": {
      "title": "Appointment Details",
      "unconfirmedAction": "Unconfirmed - Action Required",
      "notes": "Notes",
      "client": "Client:",
      "anonymous": "Anonymous",
      "resourceLabel": "Resource:",
      "durationMinutes": "{{count}} min",
      "dateTime": "Date & Time:",
      "ends": "Ends: {{time}}",
      "confirm": "Confirm",
      "reschedule": "Reschedule",
      "aiReschedule": "AI Reschedule",
      "cancel": "Cancel",
      "cancelLeadTimeDisabled": "Cancellation requires at least {{days}} days notice before the appointment starts.",
      "delete": "Delete",
      "markNoShow": "Mark No Show",
      "service": {
        "bookingType": "Service booking",
        "loading": "Loading service…",
        "confirmationDirect": "Direct booking",
        "confirmationNeedsApproval": "Needs approval",
        "assignedResources": "Assigned resources",
        "primary": "Primary"
      },
      "labels": {
        "client": "Client",
        "resource": "Resource",
        "dateTime": "Date & time",
        "format": "Format"
      },
      "meeting": {
        "title": "Meeting",
        "video": "Video",
        "inPerson": "In person",
        "moderatorLink": "Moderator link",
        "memberLink": "Guest link",
        "joinAsModerator": "Join as moderator",
        "join": "Join meeting",
        "copy": "Copy link",
        "copied": "{{link}} copied to clipboard",
        "copyFailed": "Failed to copy link"
      },
      "notesSection": {
        "empty": "No notes yet.",
        "add": "Add note",
        "edit": "Edit note",
        "modalTitle": "Appointment note",
        "modalSubtitle": "Staff-only note for {{client}} · {{date}}",
        "placeholder": "Add details staff should know about this appointment…",
        "save": "Save note",
        "saved": "Note saved",
        "saveError": "Failed to save note"
      },
      "close": "Close",
      "duration": "{{count}} min"
    },
    "manualReschedule": {
      "title": "Manual Reschedule",
      "appointmentId": "Appointment {{id}}",
      "client": "Client",
      "currentTime": "Current time",
      "duration": "Duration",
      "durationMinutes": "{{minutes}} min",
      "durationLocked": "{{minutes}} min (service duration)",
      "service": "Service",
      "primaryResource": "Primary resource",
      "assignedResources": "Assigned resources",
      "alertTitle": "Reschedule appointment",
      "alertDescription": "Select a new date and time. The client will be notified of the change.",
      "alertDescriptionService": "Select a new slot for this service booking. Duration is fixed by the service; resources may be re-assigned for the new time.",
      "newStartLabel": "New start date & time",
      "placeholder": "Select date and time",
      "endTime": "End time",
      "reschedule": "Reschedule",
      "rescheduling": "Rescheduling…",
      "success": "Appointment rescheduled successfully",
      "error": "Failed to reschedule appointment. Please try again.",
      "stillChecking": "Still checking availability. Please wait.",
      "selectValidTime": "Please select a valid date and time.",
      "slotNotAvailable": "The selected time is not available. Please choose another slot.",
      "newTime": "New time"
    },
    "resourceLink": {
      "loading": "Loading...",
      "unnamedResource": "Unnamed Resource"
    },
    "create": {
      "title": "Add Appointment",
      "success": "Appointment created successfully",
      "error": "Failed to create appointment. Please try again.",
      "timeslotBooked": "This timeslot is already booked. Please select a different time.",
      "timeNotAvailable": "Selected time is not available.",
      "exceptionPeriod": "Cannot book during exception period: {{reason}}",
      "resourceUnavailable": "Resource unavailable",
      "validationFailed": "Validation failed",
      "resource": {
        "label": "Resource",
        "required": "Please select a resource",
        "placeholder": "Select a resource",
        "allServiceLinkedTitle": "No resources available for direct booking",
        "allServiceLinkedDescription": "All resources are linked to active services. Switch to Book a service to schedule them."
      },
      "duration": {
        "label": "Duration",
        "tooltipWithPolicy": "Appointment duration in minutes. Policy requires {{minutes}} minutes.",
        "tooltip": "Appointment duration in minutes",
        "required": "Please enter duration",
        "mustBeNumber": "Duration must be a number",
        "minDuration": "Duration must be at least 5 minutes",
        "maxDuration": "Duration cannot exceed 8 hours",
        "policyDuration": "Duration must be {{minutes}} minutes per resource policy",
        "policyDurationMultiple": "Duration must be a multiple of {{minutes}} minutes (e.g. {{minutes}}, 60, 90)",
        "minutes": "minutes"
      },
      "dateTime": {
        "label": "Start Date & Time",
        "tooltipWithPolicy": "Min lead time: {{minLead}} days, Max lead time: {{maxLead}} days. Alignment: {{alignment}} min intervals.",
        "required": "Please select a start date and time",
        "pastError": "Start time cannot be in the past",
        "minLeadError": "Appointments must be booked at least {{days}} days in advance",
        "maxLeadError": "Appointments cannot be booked more than {{days}} days in advance",
        "alignmentError": "Start time must align to {{alignment}}-minute intervals (e.g., :00, :{{example1}}, :{{example2}}, etc.)",
        "maxFutureError": "Start time cannot be more than 1 year in the future",
        "policyNotYetEffective": "Policy is not yet effective for the requested time",
        "policyExpired": "Policy has expired for the requested time",
        "placeholder": "Choose date and time",
        "selectDay": "Select a date to see available times",
        "noSlotsOnDay": "No available times on this day",
        "availableTimes": "Available times",
        "timezoneHint": "Times shown in {{timezone}}",
        "calendarLegend": "Greyed-out dates have no availability. Dots mark days with open slots.",
        "loadingSlots": "Loading availability…"
      },
      "timePreview": {
        "placeholder": "Choose date and time above to see preview"
      },
      "appointmentType": {
        "label": "Appointment Guest",
        "required": "Please select an appointment guest",
        "registeredUser": "Registered User",
        "anonymousGuest": "Anonymous/Guest"
      },
      "customer": {
        "label": "Customer",
        "required": "Please select a customer",
        "placeholder": "Select a registered customer",
        "empty": "No portal customers for this tenant"
      },
      "guest": {
        "name": "Guest Name",
        "nameRequired": "Please enter guest name",
        "namePlaceholder": "Enter guest name",
        "phone": "Guest Phone",
        "phoneRequired": "Please enter guest phone",
        "phonePlaceholder": "Enter phone number",
        "phoneNumbersOnly": "Phone must contain only numbers (digits and optional + at start)",
        "phoneInvalid": "Please enter a complete, valid phone number",
        "email": "Guest Email",
        "emailPlaceholder": "Enter email address",
        "emailRequired": "Please enter guest email",
        "emailInvalid": "Please enter a valid email address"
      },
      "notes": {
        "label": "Notes",
        "help": "Optional additional information about this appointment",
        "placeholder": "Add any additional notes or details about this appointment...",
        "required": "Please enter notes"
      },
      "bookingMode": {
        "label": "Booking type",
        "resource": "Book a resource",
        "service": "Book a service",
        "resourceHint": "Schedule time on a specific resource with a custom duration.",
        "serviceHint": "Book a configured service; duration and resources follow the service setup."
      },
      "service": {
        "label": "Service",
        "required": "Please select a service",
        "placeholder": "Select a service",
        "durationTag": "{{count}} min",
        "confirmationDirect": "Direct",
        "confirmationNeedsApproval": "Approval",
        "description": "Description",
        "durationLocked": "{{count}} minutes (fixed by service)",
        "padding": "Buffer time",
        "paddingValue": "{{before}} min before, {{after}} min after",
        "selectionMode": "Resource assignment",
        "selectionAutoAssign": "Auto-assign resources",
        "selectionClientPrimary": "Client selects primary resource",
        "bookingStatus": "After booking",
        "statusConfirmed": "Creates as Confirmed",
        "statusScheduled": "Creates as Scheduled (needs approval)",
        "noServicesTitle": "No active services",
        "noServicesDescription": "Create and activate a service before booking.",
        "noServicesLink": "Manage services"
      },
      "primaryResource": {
        "label": "Primary resource",
        "required": "Please select a primary resource",
        "placeholder": "Select primary resource",
        "noCandidates": "No active resources are linked for the primary role on this service."
      },
      "reminder": {
        "label": "Create a reminder",
        "prefillTitle": "Appointment follow-up reminder"
      },
      "actions": {
        "cancel": "Cancel",
        "creating": "Creating...",
        "checkingAvailability": "Checking availability...",
        "createAppointment": "Create Appointment",
        "createConfirmed": "Create as confirmed"
      },
      "conflicts": {
        "timeslotBooked": "Timeslot Already Booked",
        "timeslotConflict": "This timeslot conflicts with an existing appointment:",
        "time": "Time:",
        "status": "Status:",
        "selectDifferentTimeOrResource": "Please select a different time or resource.",
        "outsideHours": "Outside Available Hours",
        "availableHours": "Available hours:",
        "selectWithinHours": "Please select a time within the resource's available hours.",
        "resourceUnavailable": "Resource Unavailable",
        "exceptionPeriod": "The selected time falls within an exception period:",
        "period": "Period:",
        "reason": "Reason:",
        "selectDifferentTime": "Please select a different time.",
        "checkingAvailability": "Checking availability..."
      },
      "sections": {
        "booking": "Booking",
        "dateTime": "Date & time",
        "guest": "Guest",
        "details": "Details"
      },
      "format": {
        "label": "Appointment format",
        "required": "Please select an appointment format",
        "inPerson": "In person",
        "video": "Video call"
      }
    },
    "weekdays": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "availabilityValidation": {
      "closedDay": "{{weekday}} is marked as closed for this resource.",
      "closedLabel": "Closed",
      "outsideHours": "Selected time is outside available hours for {{weekday}}.",
      "notAvailable": "Not available"
    }
  },
  "customers": {
    "title": "Customers",
    "description": "Portal customers who registered for this tenant. They appear after invite and registration.",
    "search": "Search customers",
    "empty": "No portal customers yet. Customers appear after they accept an invite and register.",
    "filters": {
      "refresh": "Refresh",
      "customersCount": "{{filtered}} of {{total}}"
    },
    "table": {
      "title": "Customers",
      "loading": "Loading customers…",
      "showingRange": "{{start}}–{{end}} of {{total}}",
      "noMatchFilters": "No customers match your search",
      "noCustomersHint": "Invite a customer from CRM; they appear here after registration.",
      "clearFilters": "Clear search"
    },
    "columns": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "membership": "Membership",
      "verified": "Verified",
      "created": "Created",
      "actions": "Actions",
      "verifiedEmail": "Email",
      "verifiedPhone": "Phone"
    },
    "remove": {
      "confirmTitle": "Remove customer?",
      "confirmDesc": "The customer loses access to this tenant.",
      "ok": "Remove",
      "cancel": "Cancel",
      "button": "Remove"
    }
  },
  "employees": {
    "title": "Employees",
    "description": "Manage team members, roles, and status.",
    "companiesAndEmployees": "Companies / Employees",
    "companiesAndEmployeesDescription": "Manage your companies and team members.",
    "companyCreateSuccess": "Company created",
    "companyUpdateSuccess": "Company updated",
    "companyDeleteSuccess": "Company deleted",
    "companyDeleteError": "Failed to delete company",
    "roles": {
      "admin": "Admin",
      "manager": "Manager",
      "agent": "Agent",
      "viewer": "Viewer",
      "owner": "Owner",
      "employee": "Employee"
    },
    "statusLabels": {
      "active": "ACTIVE",
      "inactive": "INACTIVE"
    },
    "stats": {
      "active": "active",
      "totalMembers": "total members"
    },
    "table": {
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "role": "Role",
      "tenantRole": "Tenant Role",
      "status": "Status",
      "actions": "Actions",
      "joined": "Joined",
      "loading": "Loading employees...",
      "showingRange": "Showing {{start}}-{{end}} of {{total}} employees",
      "filteredFrom": "(filtered from {{total}} total)",
      "noMatchFilters": "No employees match your filters",
      "noEmployees": "No employees yet",
      "clearFilters": "Clear filters",
      "copyEmail": "Copy",
      "copied": "Copied!"
    },
    "filters": {
      "searchPlaceholder": "Search name, email or phone",
      "rolePlaceholder": "Role",
      "clearAll": "Clear filters",
      "statusPlaceholder": "Status",
      "active": "Active",
      "inactive": "Inactive"
    },
    "actions": {
      "newEmployee": "New Employee",
      "inviteEmployee": "Invite Employee"
    },
    "selectClientHint": "Please select a client from the dropdown above",
    "noTenantHint": "No tenant selected",
    "invite": {
      "contextTitle": "Invite a team member",
      "contextTitleCompany": "Invite for {{company}}",
      "title": "Invite Employee",
      "description": "Generate an invite link to add a new team member. Share the link with the person you want to invite.",
      "roleLabel": "Role",
      "generateLink": "Generate Invite Link",
      "cancel": "Cancel",
      "close": "Close",
      "successTitle": "Invite link generated",
      "successDescription": "Share this link with the person you want to invite. The link expires in 5 days.",
      "linkDetails": "Invite Link",
      "copyLink": "Copy Registration Link",
      "copySuccess": "Link copied to clipboard",
      "tokenSuccess": "Invite link generated",
      "tokenError": "Failed to generate invite link"
    },
    "modal": {
      "editTitle": "Edit Employee",
      "createTitle": "New Employee",
      "saveButton": "Save",
      "createButton": "Create"
    },
    "form": {
      "fullName": "Full Name",
      "fullNameRequired": "Please enter full name",
      "fullNamePlaceholder": "e.g. Jane Doe",
      "email": "Email",
      "emailRequired": "Please enter a valid email",
      "emailPlaceholder": "name@example.com",
      "phone": "Phone",
      "phonePlaceholder": "Optional",
      "role": "Role",
      "status": "Status"
    },
    "messages": {
      "removeSuccess": "Employee removed",
      "removeError": "Failed to remove",
      "updateSuccess": "Employee updated",
      "createSuccess": "Employee created",
      "saveError": "Failed to save"
    },
    "tenantRoleEditor": {
      "editTooltip": "Change tenant role",
      "changeTitle": "Change tenant role",
      "selectRole": "Please select a role",
      "noChanges": "No changes to save",
      "updateSuccess": "Role updated successfully",
      "updateError": "Failed to update role",
      "editingFor": "Editing role for",
      "selectNewRole": "Select new role",
      "saveChanges": "Save changes",
      "cancel": "Cancel",
      "current": "Current",
      "confirmTitle": "Confirm role change",
      "confirmDescription": "Change role to {{role}}?"
    }
  },
  "companySettings": {
    "title": "Company Settings",
    "description": "Configure your AI Agent's behavior, tools, memory and safety.",
    "pageDescription": "Configure tenant preferences for your company.",
    "actions": {
      "resetDefaults": "Reset to Defaults",
      "save": "Save"
    },
    "weeklySummary": {
      "sectionTitle": "Weekly Smart Assistant summary",
      "sectionDescription": "Every Monday the selected recipient receives a concise summary for the previous Monday–Sunday. Weeks without interactions are not emailed.",
      "sendLabel": "Send weekly summary",
      "sendHelp": "The unsubscribe link in the email controls this same switch.",
      "recipientLabel": "Recipient",
      "recipientHelp": "Select an active member of this tenant.",
      "recipientPlaceholder": "Select a recipient",
      "recipientRequired": "Select a recipient before enabling the weekly summary.",
      "languageLabel": "Business language",
      "on": "On",
      "off": "Off",
      "languages": {
        "en": "English",
        "bg": "Български",
        "de": "Deutsch"
      },
      "selectTenant": "Select a tenant to configure company settings.",
      "saveSuccess": "Weekly email summary setting saved.",
      "saveError": "Could not save the weekly summary setting."
    },
    "model": {
      "sectionTitle": "Model",
      "sectionDescription": "These options control how your AI talks. If you're unsure, keep the defaults — they're safe and friendly for most teams.",
      "provider": "Provider",
      "providerHelp": "Who powers the AI. Different providers offer different models and pricing.",
      "modelName": "Model",
      "modelNameHelp": "The specific AI brain. Newer models usually reason better but may cost more.",
      "modelNamePlaceholder": "e.g. gpt-4o, claude-3.5-sonnet",
      "streaming": "Streaming",
      "streamingHelp": "Show the AI's answer as it's being written. Feels faster for users.",
      "temperature": "Temperature",
      "temperatureHelp": "How creative the AI should be. Lower = factual and consistent. Higher = imaginative and varied.",
      "maxTokens": "Max Tokens",
      "maxTokensHelp": "A soft limit on reply length. Higher values allow longer, more detailed answers.",
      "systemPrompt": "System Prompt",
      "systemPromptHelp": "A short role or personality for your AI. For example: 'Be concise and friendly. Ask follow‑up questions if needed.'",
      "systemPromptPlaceholder": "How should the AI behave? Keep it simple."
    },
    "knowledge": {
      "sectionTitle": "Knowledge",
      "sectionDescription": "Decide whether the AI should remember the conversation and look up answers from your knowledge base.",
      "enableMemory": "Remember conversation",
      "enableMemoryHelp": "Keeps recent chat context so the AI can refer back to what was said.",
      "enableRag": "Use company knowledge",
      "enableRagHelp": "Lets the AI search your documents/knowledge base to answer questions accurately.",
      "ragTopK": "Results to fetch",
      "ragTopKHelp": "How many matching documents to consider. Start at 5 — increase if answers miss details."
    },
    "messages": {
      "defaultsRestored": "Defaults restored",
      "settingsSaved": "Settings saved",
      "validationError": "Fix validation errors before saving"
    }
  },
  "knowledge": {
    "title": "Knowledge Base",
    "description": "Websites, documents and FAQ entries your AI agents use to answer questions.",
    "selectTenant": "Select a tenant to manage its knowledge base.",
    "stats": {
      "documents": "Documents",
      "chunks": "Indexed passages",
      "websites": "Websites",
      "activeJobs": "Processing",
      "lastSync": "Last website sync",
      "never": "Never",
      "failed": "{{count}} failed",
      "documentsHint": "Across websites, files and FAQ",
      "chunksHint": "Searchable by your AI agents",
      "pagesHint": "{{count}} pages crawled",
      "processingHint": "Indexing in progress…",
      "upToDate": "Everything is up to date"
    },
    "tabs": {
      "company": "Company",
      "websites": "Websites",
      "documents": "Documents",
      "text": "Text & FAQ",
      "search": "Test search",
      "activity": "Activity"
    },
    "status": {
      "source": {
        "IDLE": "Idle",
        "SYNCING": "Syncing",
        "READY": "Ready",
        "ERROR": "Error"
      },
      "document": {
        "PENDING": "Queued",
        "PROCESSING": "Processing",
        "INDEXED": "Indexed",
        "SKIPPED": "Skipped",
        "FAILED": "Failed"
      },
      "job": {
        "QUEUED": "Queued",
        "RUNNING": "Running",
        "SUCCEEDED": "Succeeded",
        "FAILED": "Failed",
        "CANCELLED": "Cancelled"
      }
    },
    "kinds": {
      "WEB_PAGE": "Web page",
      "FILE": "File",
      "TEXT": "Note",
      "FAQ": "FAQ"
    },
    "types": {
      "WEBSITE": "Websites",
      "DOCUMENT": "Documents",
      "TEXT": "Text & FAQ"
    },
    "jobTypes": {
      "SYNC_SOURCE": "Website sync",
      "INDEX_DOCUMENT": "Indexing"
    },
    "triggers": {
      "CREATE": "Created",
      "MANUAL": "Manual",
      "SCHEDULED": "Scheduled",
      "UPLOAD": "Upload",
      "EDIT": "Edit"
    },
    "common": {
      "actions": "Actions",
      "edit": "Edit",
      "delete": "Delete",
      "reindex": "Re-index",
      "download": "Download",
      "view": "Details",
      "refresh": "Refresh",
      "cancel": "Cancel",
      "save": "Save",
      "create": "Create",
      "status": "Status",
      "title": "Title",
      "updated": "Updated",
      "chunks": "Passages",
      "searchPlaceholder": "Search by title or URL",
      "allStatuses": "All statuses",
      "error": "Something went wrong. Please try again.",
      "reindexQueued": "Re-indexing queued",
      "deleted": "Deleted",
      "saved": "Saved",
      "all": "All",
      "noMatches": "Nothing matches your filters.",
      "showMore": "Show more",
      "showLess": "Show less"
    },
    "websites": {
      "add": "Add Website",
      "empty": "The agent will learn from your pages — services, prices, contact details — and keep them in sync automatically.",
      "columns": {
        "name": "Website",
        "pages": "Pages",
        "lastSync": "Last sync",
        "schedule": "Schedule",
        "enabled": "Enabled",
        "content": "Content"
      },
      "sync": "Sync now",
      "syncQueued": "Sync queued",
      "syncAlreadyRunning": "A sync is already running for this website",
      "deleteConfirm": "Delete this website?",
      "deleteDescription": "All crawled pages will be removed from the knowledge base.",
      "created": "Website added. The first crawl has started.",
      "lastError": "Last error",
      "failedPages": "{{count}} page(s) failed",
      "pagesCount": "{{count}} pages",
      "passagesCount": "{{count}} passages",
      "nextSync": "Next sync {{time}}",
      "intro": "Pages are crawled automatically and kept in sync on the schedule you choose.",
      "emptyTitle": "Add your company website"
    },
    "websiteForm": {
      "createTitle": "Add Website",
      "editTitle": "Edit website",
      "startUrl": "Start URL",
      "startUrlHelp": "The crawler follows links on the same domain starting from this page.",
      "startUrlInvalid": "Enter a valid http(s) URL",
      "name": "Display name",
      "namePlaceholder": "Defaults to the domain",
      "schedule": "Automatic re-sync",
      "advanced": "Crawl settings",
      "maxDepth": "Link depth",
      "maxDepthHelp": "How many clicks away from the start page to follow (0 = only the start page).",
      "maxPages": "Max pages",
      "include": "Only include paths",
      "includeHelp": "Only crawl paths matching these patterns, e.g. /products/*. Leave empty to crawl everything.",
      "exclude": "Exclude paths",
      "excludeHelp": "Never crawl paths matching these patterns, e.g. /blog/*.",
      "respectRobots": "Respect robots.txt",
      "useSitemap": "Use sitemap.xml",
      "resyncNote": "Changing crawl settings starts a new sync.",
      "respectRobotsHelp": "Skips pages the website owner has marked as off-limits for crawlers, such as checkout or account pages. Recommended to leave on.",
      "useSitemapHelp": "Also reads the website's list of all its pages, so pages that are not linked from the menu are found too. These pages count towards Max pages.",
      "maxPagesHelp": "The crawl stops after this many pages (at most 500).",
      "summary": "Depth {{depth}} · up to {{pages}} pages",
      "createButton": "Create Website"
    },
    "schedule": {
      "manual": "Manual only",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "everyHours": "Every {{count}} h"
    },
    "documents": {
      "uploadTitle": "Click or drag files here to upload",
      "uploadHint": "PDF, DOCX, TXT, MD or CSV · up to {{size}} MB per file",
      "uploaded": "{{count}} file(s) uploaded and queued for indexing",
      "rejected": "{{name}} was rejected: {{reason}}",
      "tooLarge": "{{name}} is {{actual}}; files can be at most {{size}} MB",
      "unsupported": "{{name}} cannot be uploaded: only {{types}} files are supported",
      "empty": "No documents uploaded yet.",
      "columns": {
        "file": "File",
        "size": "Size"
      },
      "deleteConfirm": "Delete this document?",
      "reindexAll": "Re-index all",
      "reindexAllConfirm": "Re-process all documents with the latest extraction?",
      "reindexAllQueued": "{{count}} document(s) queued for re-indexing"
    },
    "text": {
      "addFaq": "Add FAQ",
      "addNote": "Add Note",
      "empty": "Write FAQ entries and notes for things that are not on your website — policies, pricing details, internal know-how.",
      "faqTitle": "Add FAQ",
      "noteTitle": "Add Note",
      "editFaq": "Edit FAQ entry",
      "editNote": "Edit note",
      "question": "Question",
      "answer": "Answer",
      "title": "Title",
      "content": "Content",
      "titleOptional": "Title (optional)",
      "required": "This field is required",
      "deleteConfirm": "Delete this entry?",
      "entry": "Entry",
      "emptyTitle": "Answer common questions directly",
      "searchPlaceholder": "Search questions and notes",
      "createFaq": "Create FAQ",
      "createNote": "Create Note"
    },
    "detail": {
      "pages": "Pages",
      "jobs": "Sync history",
      "content": "Extracted text",
      "chunks": "Indexed passages",
      "noChunks": "Nothing indexed yet.",
      "info": "Details",
      "url": "URL",
      "depth": "Depth",
      "httpStatus": "HTTP status",
      "error": "Error",
      "indexedAt": "Indexed",
      "size": "Size",
      "kind": "Type",
      "page": "Page {{page}}",
      "tokens": "~{{count}} tokens",
      "truncated": "Showing the first {{count}} characters.",
      "pageColumn": "Page",
      "siteWide": "Site-wide",
      "siteWideHint": "Content repeated on several pages (contact boxes, teasers, footers). It is indexed once here instead of on every page."
    },
    "search": {
      "description": "Ask a question the way a customer would. These are the passages your AI agent receives to answer it.",
      "placeholder": "e.g. What are your opening hours?",
      "run": "Search",
      "topK": "Results",
      "sources": "Sources",
      "allSources": "All sources",
      "empty": "Run a search to preview retrieval results.",
      "noResults": "No relevant passages. The agent would say it does not know rather than guess.",
      "score": "Relevance {{score}}",
      "took": "{{count}} results in {{ms}} ms",
      "examples": [
        "What are your opening hours?",
        "What services do you offer?",
        "How can I contact you?"
      ],
      "relevance": {
        "strong": "Strong match",
        "good": "Good match",
        "weak": "Weak match",
        "keyword": "Keyword match"
      },
      "similarityTooltip": "Semantic similarity {{value}} (0–1)",
      "keywordTooltip": "Matched your words exactly, without a strong semantic match"
    },
    "jobs": {
      "empty": "No ingestion activity yet.",
      "columns": {
        "type": "Job",
        "target": "Source / document",
        "trigger": "Trigger",
        "status": "Status",
        "result": "Result",
        "started": "Started",
        "duration": "Duration"
      },
      "summary": "{{indexed}} indexed · {{unchanged}} unchanged · {{skipped}} skipped · {{failed}} failed · {{removed}} removed",
      "attempt": "Attempt {{attempts}}/{{max}}",
      "retryAt": "Retry {{time}}"
    },
    "company": {
      "title": "Company information",
      "description": "Name, address, contact details and opening hours your AI agent answers with (getCompanyInformation tool). Taken from your website's structured data and contact page on every sync; your edits take priority.",
      "edit": "Edit",
      "editTitle": "Edit company information",
      "editHelp": "Changes override the values found on your website and are kept on future syncs. Fields that match the website keep following it automatically.",
      "resetToWebsite": "Use website value",
      "clear": "Clear",
      "openingHoursHelp": "Type an entry and press Enter, e.g. \"Mo-Fr 08:00-18:00\" or \"Sa closed\".",
      "emptyNoWebsite": "No company information yet. Add your website and it will be read automatically.",
      "emptyNoData": "No company information was found on your website yet. Add it manually with Edit.",
      "addWebsite": "Add Website",
      "extractedFrom": "Extracted from {{sources}}",
      "origin": {
        "jsonld": "Website data",
        "website": "Contact page",
        "override": "Edited"
      },
      "fields": {
        "name": "Name",
        "legalName": "Legal name",
        "address": "Address",
        "phones": "Phone",
        "emails": "Email",
        "fax": "Fax",
        "openingHours": "Opening hours",
        "website": "Website",
        "socialLinks": "Social media",
        "areaServed": "Area served",
        "priceRange": "Price range",
        "description": "Description"
      },
      "address": {
        "street": "Street and number",
        "postalCode": "Postal code",
        "city": "City",
        "region": "Region",
        "country": "Country"
      },
      "placeholders": {
        "phones": "Add a phone number",
        "emails": "Add an email address",
        "openingHours": "Add opening hours",
        "socialLinks": "Add a profile URL"
      }
    }
  },
  "permissions": {
    "title": "Permissions Management",
    "connectProfiles": {
      "title": "Connect Profiles",
      "description": "Connect your profile with other services to streamline your login process.",
      "connectGoogle": "Connect with Google",
      "googleSuccess": "Google account connected successfully!",
      "googleError": "Failed to connect Google account"
    },
    "userPermissions": {
      "title": "User Permissions",
      "description": "Manage user roles and permissions for your organization."
    }
  },
  "shop": {
    "title": "Shop",
    "description": "Operate your online shop with AI assistance for fulfillment, pricing, and content.",
    "stats": {
      "orders": "Orders",
      "pending": "Pending",
      "paid": "Paid",
      "revenue": "Revenue"
    },
    "orders": {
      "title": "Orders",
      "searchPlaceholder": "Search orders...",
      "filterPending": "Pending",
      "filterPaid": "Paid",
      "filterFulfilled": "Fulfilled",
      "filterCancelled": "Cancelled",
      "filterAll": "All",
      "table": {
        "order": "Order",
        "customer": "Customer",
        "total": "Total",
        "status": "Status",
        "actions": "Actions",
        "items": "{{count}} items"
      },
      "actions": {
        "fulfill": "Fulfill",
        "cancel": "Cancel"
      },
      "messages": {
        "fulfilling": "AI preparing fulfillment steps...",
        "fulfillSuccess": "Order fulfilled. Shipping label and email prepared by AI.",
        "cancelTitle": "Cancel Order",
        "cancelContent": "This will notify the customer and restock items.",
        "cancelButton": "Cancel Order",
        "cancelling": "AI drafting cancellation email...",
        "cancelSuccess": "Order cancelled and email sent."
      }
    },
    "products": {
      "title": "Products",
      "newProduct": "New Product",
      "table": {
        "product": "Product",
        "sku": "SKU",
        "price": "Price",
        "stock": "Stock",
        "category": "Category",
        "status": "Status",
        "actions": "Actions"
      },
      "statusActive": "ACTIVE",
      "statusInactive": "INACTIVE",
      "actions": {
        "aiPrice": "AI Price",
        "aiDescription": "AI Description",
        "edit": "Edit"
      },
      "drawer": {
        "editTitle": "Edit Product",
        "createTitle": "New Product",
        "cancel": "Cancel",
        "save": "Save"
      },
      "form": {
        "name": "Name",
        "nameRequired": "Enter product name",
        "namePlaceholder": "e.g. Premium Hoodie",
        "sku": "SKU",
        "skuPlaceholder": "Optional",
        "category": "Category",
        "categoryPlaceholder": "e.g. Merch",
        "price": "Price",
        "stock": "Stock"
      },
      "messages": {
        "updateSuccess": "Product updated",
        "createSuccess": "Product created",
        "aiAnalyzing": "AI analyzing similar products and demand...",
        "aiSuggestedPrice": "Suggested price: ${{price}}"
      },
      "aiDescription": {
        "title": "AI Product Description",
        "body": "A carefully crafted item your customers will love. Clear value, modern design, and reliable quality.",
        "highlights": "Highlights: fast delivery, easy returns, and excellent support."
      }
    }
  },
  "tasksProjects": {
    "title": "Tasks & Projects",
    "description": "Plan and track work for your AI agent and team.",
    "stats": {
      "myOpenTasks": "My Open Tasks",
      "teamOpenTasks": "Team Open Tasks",
      "projectsInProgress": "Projects In Progress"
    },
    "tabs": {
      "overview": "Overview",
      "projects": "Projects",
      "notifications": "Notifications"
    },
    "tasks": {
      "myTasks": "My Tasks",
      "teamTasks": "Team Tasks",
      "addPersonalPlaceholder": "Add a personal task",
      "addTeamPlaceholder": "Add a team task",
      "addButton": "Add",
      "noTasks": "No tasks",
      "statusNotStarted": "Not started",
      "statusInProgress": "In progress",
      "statusDone": "Done",
      "priorityLow": "Low",
      "priorityMedium": "Medium",
      "priorityHigh": "High",
      "due": "Due {{date}}"
    },
    "projects": {
      "backlog": "Backlog",
      "inProgress": "In Progress",
      "done": "Done"
    },
    "notifications": {
      "title": "Upcoming & Recent"
    }
  },
  "videoMeetings": {
    "title": "Video Meetings",
    "description": "View and manage video meetings with your customers.",
    "stats": {
      "totalMeetings": "Total Meetings",
      "scheduled": "Scheduled",
      "confirmed": "Confirmed",
      "today": "Today"
    },
    "filters": {
      "searchPlaceholder": "Search meetings...",
      "statusPlaceholder": "Filter by status",
      "scheduled": "Scheduled",
      "confirmed": "Confirmed",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "noShow": "No Show",
      "startDate": "Start date",
      "endDate": "End date",
      "clear": "Clear"
    },
    "table": {
      "client": "Client",
      "meetingDetails": "Meeting Details",
      "dateTime": "Date & Time",
      "status": "Status",
      "actions": "Actions",
      "minutes": "{{count}} minutes",
      "anonymous": "Anonymous",
      "interviewTitle": "Interview: {{position}}",
      "appointmentTitle": "Appointment {{id}}",
      "interviewDescription": "Interview for position: {{position}}",
      "title": "Video meetings",
      "empty": "No video meetings yet",
      "noMatchFilters": "No meetings match your filters"
    },
    "actions": {
      "viewDetails": "View Details",
      "joinMeeting": "Join Meeting",
      "copyUrl": "Copy URL",
      "copyMeetingUrl": "Copy Meeting URL"
    },
    "messages": {
      "urlCopied": "Meeting URL copied to clipboard!",
      "urlCopyFailed": "Failed to copy URL to clipboard",
      "noMeetingUrl": "No meeting URL available for this appointment"
    },
    "pagination": "{{start}}-{{end}} of {{total}} meetings"
  },
  "clients": {
    "title": "Client Leads",
    "description": "Manage leads.",
    "addNewLead": "Add New Lead",
    "stats": {
      "totalLeads": "Total Leads",
      "registered": "Registered",
      "active": "Active",
      "converted": "Converted"
    },
    "filters": {
      "searchPlaceholder": "Search by name, email, or phone",
      "statusPlaceholder": "Status",
      "sourcePlaceholder": "Source",
      "registrationPlaceholder": "Registration",
      "clearFilters": "Clear Filters",
      "export": "Export"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "converted": "Converted"
    },
    "source": {
      "websiteWidget": "Website Widget",
      "email": "Email",
      "voiceCall": "Voice Call",
      "sms": "SMS",
      "socialMedia": "Social Media",
      "other": "Other"
    },
    "registration": {
      "registered": "Registered",
      "unregistered": "Unregistered"
    },
    "table": {
      "client": "Client",
      "status": "Status",
      "registration": "Registration",
      "source": "Source",
      "tags": "Tags",
      "lastInteraction": "Last Interaction",
      "actions": "Actions"
    },
    "fallback": {
      "anonymousClient": "Anonymous Client",
      "unknownClient": "Unknown Client",
      "noContactInfo": "No contact information"
    },
    "actions": {
      "viewDetails": "View Details",
      "edit": "Edit",
      "register": "Register",
      "delete": "Delete",
      "viewChatHistory": "View chat history",
      "viewMeetingHistory": "View meeting history"
    },
    "pagination": "{{start}}-{{end}} of {{total}} leads",
    "modal": {
      "editTitle": "Edit Client Lead",
      "createTitle": "Create New Client Lead",
      "updateButton": "Update Lead",
      "createButton": "Create Lead"
    },
    "form": {
      "fullName": "Full Name",
      "fullNameRequired": "Please enter a name",
      "fullNamePlaceholder": "Enter client name",
      "source": "Source",
      "sourceRequired": "Please select a source",
      "sourcePlaceholder": "Select source",
      "email": "Email Address",
      "emailInvalid": "Please enter a valid email",
      "emailPlaceholder": "Enter email address",
      "phone": "Phone Number",
      "phonePlaceholder": "Enter phone number",
      "tags": "Tags",
      "tagsPlaceholder": "Enter tags (press Enter to add)"
    },
    "messages": {
      "createSuccess": "Client lead created successfully!",
      "createError": "Failed to create client lead",
      "updateSuccess": "Client lead updated successfully!",
      "updateError": "Failed to update client lead",
      "deleteTitle": "Are you sure you want to delete this client lead?",
      "deleteContent": "This action cannot be undone.",
      "deleteOk": "Yes, Delete",
      "deleteSuccess": "Client lead deleted successfully!",
      "deleteError": "Failed to delete client lead",
      "registerSuccess": "Client lead registered successfully!",
      "registerError": "Failed to register client lead"
    },
    "meetingHistory": {
      "title": "Meeting History",
      "modalTitle": "Meeting History - {{name}}",
      "videoMeeting": "Video Meeting",
      "inPersonMeeting": "In-Person Meeting",
      "noAgentAssigned": "No agent assigned",
      "notes": "Notes:",
      "tags": "Tags:",
      "loading": "Loading meeting history...",
      "noHistory": "No meeting history found for this client.",
      "noHistoryHint": "Meetings will appear here once the client has scheduled appointments."
    }
  },
  "leads": {
    "title": "Leads",
    "description": "Track and manage leads captured from all channels.",
    "loadError": "Failed to load leads",
    "tryAgain": "Try Again",
    "stats": {
      "totalLeads": "Total Leads",
      "newLeads": "New",
      "qualifiedLeads": "Qualified",
      "disqualifiedLeads": "Disqualified",
      "convertedLeads": "Converted"
    },
    "filters": {
      "searchPlaceholder": "Search by name, email, or phone...",
      "statusPlaceholder": "All Statuses",
      "channelPlaceholder": "All Channels",
      "refresh": "Refresh",
      "clearAll": "Clear All",
      "activeFilters": "Active filters:",
      "searchTag": "Search: \"{{text}}\"",
      "statusTag": "Status: {{status}}",
      "channelTag": "Channel: {{channel}}",
      "leadsCount": "{{filtered}} / {{total}} leads"
    },
    "status": {
      "NEW": "New",
      "QUALIFIED": "Qualified",
      "DISQUALIFIED": "Disqualified",
      "CONVERTED": "Converted"
    },
    "channel": {
      "CHAT_WIDGET": "Chat Widget",
      "EMAIL": "Email",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "PHONE_CALL": "Phone Call",
      "OTHER": "Other"
    },
    "table": {
      "title": "All Leads",
      "lead": "Lead",
      "channel": "Channel",
      "status": "Status",
      "verified": "Verified",
      "created": "Created",
      "lastUpdated": "Last Updated",
      "actions": "Actions",
      "viewDetails": "View Details",
      "view": "View",
      "loading": "Loading leads...",
      "leadCount": "{{count}} lead",
      "leadCount_plural": "{{count}} leads",
      "showingRange": "Showing {{start}}-{{end}} of {{total}} leads",
      "noMatchFilters": "No leads match your filter criteria",
      "noLeadsFound": "No leads found yet",
      "noLeadsHint": "Leads will appear here as they are captured through your channels.",
      "clearFilters": "Clear Filters",
      "emailVerified": "Email Verified",
      "phoneVerified": "Phone Verified",
      "notVerified": "Not Verified",
      "anonymous": "Anonymous Lead",
      "noContactInfo": "No contact info",
      "authenticated": "Authenticated via email code",
      "authenticatedShort": "Auth",
      "ip": "IP",
      "convert": "Convert"
    },
    "convert": {
      "convertToCustomer": "Convert to Customer",
      "confirmTitle": "Convert lead to customer?",
      "confirmDescription": "A customer profile will be created from this lead's contact and verification data.",
      "success": "{{name}} promoted to customer",
      "error": "Failed to convert lead to customer",
      "requiresVerification": "Email or phone must be verified before conversion",
      "alreadyConverted": "This lead has already been converted",
      "converting": "Converting..."
    }
  },
  "leadDetail": {
    "loading": "Loading lead details...",
    "notFound": "Lead not found",
    "notFoundDescription": "The lead may have been deleted or doesn't exist.",
    "backToLeads": "Back to Leads",
    "title": "Lead Details",
    "leadIdCopied": "Lead ID copied to clipboard",
    "header": {
      "back": "Back",
      "leadProfile": "Lead Profile",
      "copyLeadId": "Copy Lead ID",
      "id": "ID: {{id}}"
    },
    "sidebar": {
      "contactInfo": "Contact Information",
      "email": "Email",
      "phone": "Phone",
      "noEmail": "No email provided",
      "noPhone": "No phone provided",
      "verificationStatus": "Verification",
      "emailVerified": "Email Verified",
      "emailNotVerified": "Email Not Verified",
      "phoneVerified": "Phone Verified",
      "phoneNotVerified": "Phone Not Verified",
      "timeline": "Timeline",
      "created": "Created",
      "lastUpdated": "Last Updated",
      "convertedAt": "Conversion Status",
      "notConverted": "Not converted yet",
      "source": "Source",
      "channel": "Channel",
      "sourceThread": "Source Thread",
      "sourceSession": "Source Session",
      "noThread": "No thread linked",
      "noSession": "No session linked",
      "viewThread": "View Thread",
      "sessionIdentity": "Session & Identity",
      "lastKnownIp": "Last Known IP",
      "lastKnownUserAgent": "User Agent",
      "authenticated": "Authenticated",
      "authenticatedAt": "Authenticated At",
      "authenticatedSessionId": "Authenticated Session",
      "fingerprint": "Fingerprint",
      "noSessionIdentity": "No session or identity data"
    },
    "content": {
      "notes": "Notes",
      "noNotes": "No notes added yet.",
      "metadata": "Additional Data",
      "noMetadata": "No additional data available.",
      "conversionInfo": "Conversion",
      "convertedCustomer": "Converted Customer ID",
      "statusNotConverted": "This lead has not been converted yet.",
      "convertButton": "Convert to Customer",
      "convertSuccess": "{{name}} promoted to customer",
      "requestVerification": "Request verification from this lead",
      "requestVerificationSuccess": "Verification request sent",
      "requestVerificationPending": "A verification request is already active for this lead",
      "requestVerificationError": "Could not request verification"
    },
    "contactEdit": {
      "edit": "Edit",
      "title": "Edit contact details",
      "emailLabel": "Email",
      "phoneLabel": "Phone",
      "phonePlaceholder": "+359888123456",
      "emailInvalid": "Enter a valid email address",
      "phoneInvalid": "Enter an international number, e.g. +359888123456",
      "atLeastOne": "Enter an email or a phone",
      "verificationWarning": "Changing the email or phone resets its verification. Any pending verification link sent to the old value stops working.",
      "save": "Save",
      "success": "Contact details updated",
      "error": "Failed to update contact details",
      "nothingChanged": "No changes to save"
    }
  },
  "clientDetail": {
    "loading": "Loading client details...",
    "notFound": "Client not found",
    "backToClients": "Back to Clients",
    "title": "Client Details",
    "noContactInfo": "No contact information available",
    "lastInteraction": "Last interaction: {{time}}",
    "channel": "Channel: {{channel}}",
    "tags": "Tags",
    "chat": {
      "sessions": "Chat Sessions",
      "noSessions": "No chat sessions yet",
      "aiAssistant": "AI Assistant",
      "human": "Human",
      "chatWith": "Chat with {{name}}",
      "selectSession": "Select a chat session to view messages",
      "noMessages": "No messages in this session",
      "selectSessionHint": "Select a chat session from the left to view messages",
      "messagePlaceholder": "Type your message...",
      "send": "Send"
    },
    "actions": {
      "takeOver": "Take Over",
      "endSession": "End Session"
    },
    "endSessionModal": {
      "title": "End Chat Session",
      "content": "Are you sure you want to end this chat session?",
      "okText": "End Session"
    },
    "takeoverModal": {
      "title": "Take Over Chat Session",
      "description": "You are about to take over this conversation from the AI agent. The client will be notified that a human agent is now handling their request.",
      "yourName": "Your Name",
      "yourNameRequired": "Please enter your name",
      "defaultName": "Human Agent",
      "namePlaceholder": "Enter your name",
      "takeOver": "Take Over"
    },
    "messages": {
      "sendError": "Failed to send message",
      "endSessionSuccess": "Chat session ended",
      "endSessionError": "Failed to end session",
      "takeoverSuccess": "Successfully took over the conversation",
      "takeoverError": "Failed to takeover session"
    }
  },
  "threads": {
    "title": "Communication Threads",
    "description": "View and manage communication threads from your customers.",
    "inactivityArchivedHelp": "Webchat threads with 4 hours of inactivity are automatically marked as Archived.",
    "loadError": "Failed to load communications",
    "tryAgain": "Try Again",
    "stats": {
      "totalThreads": "Total Threads",
      "filtered": "Filtered",
      "activeFlows": "Active Flows",
      "recent24h": "Recent (24h)"
    },
    "filters": {
      "searchPlaceholder": "Search by title, summary, or flow name...",
      "refresh": "Refresh",
      "customDateRange": "Custom Date Range:",
      "today": "Today",
      "yesterday": "Yesterday",
      "thisWeek": "This Week",
      "thisMonth": "This Month",
      "activeFilters": "Active filters:",
      "searchTag": "Search: \"{{text}}\"",
      "timeTag": "Time: {{label}}",
      "clearAll": "Clear All",
      "threadsCount": "{{filtered}} / {{total}} threads",
      "active": "Active",
      "hidden": "Hidden ({{count}})"
    },
    "timePresets": {
      "all": "All Time",
      "24h": "Last 24h",
      "7d": "Last 7 days",
      "30d": "Last 30 days",
      "90d": "Last 90 days",
      "custom": "Custom"
    },
    "status": {
      "active": "Active",
      "closed": "Closed",
      "pending": "Pending",
      "archived": "Archived",
      "unknown": "Unknown"
    },
    "table": {
      "title": "Communication Threads",
      "thread": "Thread",
      "flow": "Flow",
      "user": "User",
      "status": "Status",
      "created": "Created",
      "lastUpdated": "Last Updated",
      "actions": "Actions",
      "threadId": "Thread ID: {{id}}",
      "copyId": "Copy ID",
      "copied": "Copied!",
      "session": "Session: {{id}}",
      "noSession": "No session",
      "flowId": "Flow ID: {{id}}",
      "userId": "User ID: {{id}}",
      "copyUserId": "Copy User ID",
      "anonymous": "Anonymous",
      "identified": "Identified",
      "viewConversation": "View conversation",
      "view": "View",
      "archive": "Archive",
      "archiveTooltip": "Archive this thread",
      "threadCount": "{{count}} thread",
      "threadCount_plural": "{{count}} threads",
      "loading": "Loading communications...",
      "showingRange": "Showing {{start}}-{{end}} of {{total}} threads",
      "filteredFrom": "(filtered from {{total}})",
      "noMatchFilters": "No threads match your filter criteria",
      "noThreadsFound": "No communication threads found",
      "clearFilters": "Clear Filters",
      "hide": "Hide",
      "hideTooltip": "Hide from the list. The thread is kept and still counted in statistics.",
      "showAgain": "Show again",
      "showAgainTooltip": "Bring this thread back to the main list",
      "delete": "Delete",
      "hideSelected": "Hide ({{count}})",
      "showAgainSelected": "Show again ({{count}})",
      "deleteSelected": "Delete ({{count}})",
      "hiddenSuccess": "Thread hidden",
      "shownAgainSuccess": "Thread shown again",
      "hideError": "Could not hide the thread(s)",
      "showAgainError": "Could not show the thread(s) again",
      "moreActions": "More actions",
      "hiddenAgo": "Hidden {{ago}}",
      "noHiddenThreads": "No hidden threads. Hidden threads stay counted in statistics and come back when the customer writes again.",
      "hiddenSuccess_plural": "{{count}} threads hidden",
      "shownAgainSuccess_plural": "{{count}} threads shown again",
      "sourceWebchat": "Webchat",
      "sourceEmail": "Email",
      "sourcePhone": "Phone"
    }
  },
  "threadDetail": {
    "notFound": "Thread not found",
    "notFoundDescription": "The thread may have been deleted or doesn't exist",
    "backToCommunications": "Back to Communications",
    "threadIdCopied": "Thread ID copied to clipboard",
    "archiveSuccess": "Thread archived",
    "archiveError": "Failed to archive thread",
    "header": {
      "back": "Back",
      "conversationThread": "Conversation Thread",
      "copyThreadId": "Copy Thread ID",
      "archive": "Archive",
      "id": "ID: {{id}}"
    },
    "sidebar": {
      "messages": "Messages",
      "duration": "Duration",
      "noData": "—",
      "threadDetails": "Thread Details",
      "summary": "Summary",
      "flow": "Flow",
      "flowId": "Flow ID: {{id}}",
      "noFlowAssigned": "No flow assigned",
      "fromNumber": "From",
      "toNumber": "To",
      "fromEmail": "From",
      "toEmail": "To",
      "callStatus": "Call Status",
      "provider": "Provider",
      "started": "Started",
      "lastActivity": "Last Activity",
      "lastMessageBy": "Last Message By",
      "noMessagesYet": "No messages yet"
    },
    "message": {
      "toEmail": "To: {{email}}"
    },
    "conversation": {
      "title": "Conversation",
      "messageCount": "{{count}} messages",
      "updating": "Updating...",
      "noMessagesTitle": "No messages yet",
      "noMessagesDescription": "Messages will appear here once the conversation starts"
    },
    "roles": {
      "aiAssistant": "AI Assistant",
      "user": "User",
      "system": "System",
      "tool": "Tool",
      "toolResponse": "Tool Response"
    },
    "toolCard": {
      "label": "Tool",
      "details": "Details",
      "rawJson": "Raw JSON"
    },
    "dateSeparator": {
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "duration": {
      "zero": "0s",
      "daysHours": "{{days}}d {{hours}}h",
      "hoursMinutes": "{{hours}}h {{minutes}}m",
      "minutesSeconds": "{{minutes}}m {{seconds}}s",
      "seconds": "{{seconds}}s"
    }
  },
  "services": {
    "title": "Services",
    "description": "Define bookable services, scheduling rules, and what the AI agent needs to collect from clients",
    "addService": "Add Service",
    "stats": {
      "total": "Total services",
      "active": "Active",
      "inactive": "Inactive"
    },
    "loading": "Loading services...",
    "inactiveHint": "Inactive services are not offered in the AI chat.",
    "table": {
      "service": "Service",
      "booking": "Booking",
      "setup": "Setup",
      "duration": "Duration",
      "confirmation": "Confirmation",
      "active": "Active",
      "actions": "Actions",
      "noRequirements": "No roles defined",
      "noMatchFilters": "No services match your filters",
      "noServices": "No services yet",
      "durationMinutes": "{{count}} min",
      "confirmationDirect": "Direct booking",
      "confirmationNeedsApproval": "Needs approval",
      "selectionAutoShort": "Auto-assign",
      "selectionClientShort": "Client choice",
      "callbackRequest": "Callback request",
      "callbackNoAppointment": "No appointment or time slot",
      "callbackNoResources": "No scheduling resources required",
      "customSchedule": "Custom hours",
      "resourceHours": "Resource hours",
      "rolesCount": "{{count}} roles",
      "linkedResources": "{{count}} linked",
      "linkedResourcesDetail": "{{active}} active · {{total}} linked",
      "readinessReady": "Ready",
      "readinessNoRoles": "No roles",
      "readinessNoClientContact": "No client contact",
      "readinessUnderStaffed": "Needs resources",
      "verificationRequired": "Verification required"
    },
    "filters": {
      "title": "Services",
      "searchPlaceholder": "Search services...",
      "allStatuses": "All statuses",
      "active": "Active",
      "inactive": "Inactive",
      "servicesCount": "services",
      "searchTag": "Search: {{text}}",
      "activeFilters": "Active filters",
      "clearAll": "Clear filters"
    },
    "tooltips": {
      "manageService": "Manage service",
      "deleteService": "Delete service"
    },
    "pagination": "{{start}}-{{end}} of {{total}} services",
    "activeToggle": {
      "success": "Service status updated",
      "error": "Failed to update service status",
      "noRoles": "Add at least one role on the Resources tab before activating this service.",
      "noClientContact": "Select Email or Phone under Required client info before activating this service."
    }
  },
  "serviceModals": {
    "create": {
      "title": "Add Service",
      "description": "Create the service with the basic details.",
      "saveHint": "After saving, you can configure availability, linked resources, and AI instructions in the service settings.",
      "createButton": "Create Service",
      "successMessage": "Service created successfully",
      "errorMessage": "Failed to create service"
    },
    "edit": {
      "title": "Edit service",
      "description": "Update service configuration",
      "updateButton": "Save changes",
      "successMessage": "Service updated successfully",
      "errorMessage": "Failed to update service",
      "loading": "Loading service..."
    },
    "delete": {
      "title": "Delete service",
      "deleteButton": "Delete",
      "confirmMessage": "Are you sure you want to delete \"{{name}}\"? This cannot be undone.",
      "successMessage": "Service deleted successfully",
      "errorMessage": "Failed to delete service"
    }
  },
  "serviceForm": {
    "sections": {
      "basic": "Basic info",
      "availability": "Availability rules (optional)",
      "requirements": "Resource requirements",
      "aiInstructions": "AI instructions",
      "clientInfo": "Required client info",
      "linkedResources": "Linked resources"
    },
    "availabilityEmptyDescription": "No service-level hours are set yet. Resource working hours still apply. Configure weekly windows below to restrict when this service can be booked.",
    "name": "Service name",
    "nameRequired": "Enter a service name",
    "namePlaceholder": "e.g. On-site assessment",
    "description": "Description",
    "descriptionPlaceholder": "Brief description for staff and the booking agent",
    "durationMinutes": "Duration (min)",
    "durationRequired": "Enter duration in minutes",
    "paddingBefore": "Before (min)",
    "paddingAfter": "After (min)",
    "paddingBeforeTooltip": "Buffer time before the appointment",
    "paddingAfterTooltip": "Buffer time after the appointment",
    "fulfillmentMode": "Fulfillment",
    "fulfillmentAppointment": "Appointment",
    "fulfillmentCallback": "Callback request",
    "fulfillmentAppointmentHelp": "Creates a scheduled appointment using availability and linked resources.",
    "fulfillmentCallbackHelp": "Collects the client's name, phone, and preferred callback time. It does not create an appointment or use availability and resources.",
    "confirmationMode": "Confirmation",
    "confirmationModeCallbackHint": "Not applicable for callback requests — confirmed when the request is submitted.",
    "confirmationDirect": "Direct — confirmed immediately",
    "confirmationNeedsApproval": "Needs approval — scheduled until confirmed",
    "selectionMode": "Resource selection",
    "selectionAutoAssign": "Auto-assign all required resources",
    "selectionClientPrimary": "Client chooses primary resource",
    "availabilityHelp": "Leave all days closed to use only resource working hours. Set windows to restrict when this service can be booked.",
    "copyMonday": "Copy Monday to weekdays",
    "copyMondaySuccess": "Monday hours copied to Tue–Fri",
    "dayOpen": "Open",
    "requirementsHelp": "Define resource roles and how many are needed per booking. Assign specific resources on the Resources tab.",
    "addRequirement": "Add requirement",
    "quantity": "Quantity",
    "primaryChoice": "Client chooses this type",
    "removeRequirement": "Remove",
    "aiInstructions": "Instructions for the booking agent",
    "aiInstructionsHelp": "Plain-language guidance for the AI (not a form builder). Example: which options to offer or what not to ask.",
    "aiInstructionsPlaceholder": "e.g. Offer available barbers and book the one the client chooses.",
    "clientInfoName": "Name",
    "clientInfoEmail": "Email",
    "clientInfoPhone": "Phone",
    "clientInfoNotes": "Notes",
    "clientInfoActivationHelp": "Name is always required. Email and Phone control what the chat/widget collects (and verifies, when identity verification is on). Select at least one before activating this service. Phone calls do not use these Email/Phone boxes.",
    "callbackClientInfoActivationHelp": "Callback requests always require Name and Phone. Email, notes, and custom fields are optional.",
    "customClientInfoTitle": "Custom fields",
    "customClientInfoHelp": "Add extra client info fields the booking agent should collect. Turn Required on to make a field mandatory.",
    "customClientInfoKeyPlaceholder": "Field name (e.g. companyName)",
    "customClientInfoRequired": "Required",
    "customClientInfoAdd": "Add custom field",
    "customClientInfoRemove": "Remove custom field",
    "requiredVerification": "Require identity verification",
    "requiredVerificationHelp": "These Email and Phone boxes apply only to chat/widget: Email only verifies with an email code, Phone only with an SMS code, and both follow whichever the client provided. Phone calls ignore these boxes. When verification is required, a matching caller number is auto-verified; otherwise the caller is asked for a mobile number and sent an SMS code, and refusal blocks the booking.",
    "aliases": "Localized names",
    "aliasesHelp": "Optional names in other languages so the AI agent can match this service in multilingual chats.",
    "aliasNamePlaceholder": "Service name in this language",
    "isActive": "Active",
    "isActiveHelp": "Inactive services are hidden from the AI chat",
    "isActiveOnTitle": "Service is live",
    "isActiveOffTitle": "Service is hidden",
    "isActiveOnHint": "Clients can discover and book this service through the AI agent.",
    "isActiveOffHint": "Turn on when you are ready to offer this service in chat.",
    "isActiveNoRolesWarningTitle": "Add roles before going live",
    "isActiveNoRolesWarningDescription": "An active service needs at least one role on the Resources tab (e.g. barber, room). Define roles and link resources there, then save.",
    "isActiveNoClientContactWarningTitle": "Add client contact info before going live",
    "isActiveNoClientContactWarningDescription": "Select Email or Phone under Required client info. Every booking needs a client name plus at least one contact method.",
    "isActiveNoCallbackContactWarningDescription": "Callback requests require both Name and Phone.",
    "isActiveSwitchOn": "On",
    "isActiveSwitchOff": "Off",
    "linkedResourcesSummary": "{{active}} active and {{inactive}} inactive links for \"{{type}}\" (requires {{required}})",
    "linkedResourcesInsufficient": "Only {{active}} active resource(s) linked for \"{{type}}\" but {{required}} required.",
    "validation": {
      "primaryChoiceCount": "With client primary selection, exactly one requirement must be marked as client choice.",
      "primaryChoiceQuantity": "The client-choice requirement must have quantity 1.",
      "clientPrimaryNoRoles": "Add at least one role on the Resources tab before enabling client primary selection.",
      "activeRequiresRoles": "Add at least one role on the Resources tab before activating this service.",
      "activeRequiresClientContact": "Select Email or Phone under Required client info before activating this service.",
      "clientPrimaryConfigureOnResourcesTab": "Open the Resources tab, mark exactly one role as \"Client chooses this type\", and set its quantity to 1 — then save again.",
      "requiredVerificationContactRequired": "Select Email or Phone. At least one is required while identity verification is on.",
      "requiredVerificationEmailRequired": "Email must be required when verification is enabled.",
      "customClientInfoKeyRequired": "Enter a field name.",
      "customClientInfoKeyInvalid": "Field name must be 1–128 characters with no leading or trailing spaces.",
      "customClientInfoKeyReserved": "Name, email, phone, and notes are already listed above.",
      "customClientInfoKeyDuplicate": "This field name is already used.",
      "endAfterStart": "End time must be after start time",
      "splitNotSupported": "Lunch-break schedules are not supported for services. Use continuous hours or closed for each day."
    }
  },
  "resources": {
    "title": "Company Resources",
    "description": "Manage schedulable resources like doctors, rooms, equipment, and vehicles",
    "addResource": "Add Resource",
    "stats": {
      "totalResources": "Total Resources",
      "people": "People",
      "rooms": "Rooms",
      "equipment": "Equipment"
    },
    "loading": "Loading resources...",
    "table": {
      "resource": "Resource",
      "noMatchFilters": "No resources match your filters",
      "noResources": "No resources yet",
      "translations": "Translations",
      "serviceRoles": "Service roles",
      "noServiceRoles": "None",
      "metadata": "Metadata",
      "created": "Created",
      "actions": "Actions",
      "unnamedResource": "Unnamed Resource",
      "noMetadata": "No metadata",
      "moreMetadata": "+{{count}} more",
      "viewMetadata": "View JSON"
    },
    "filters": {
      "title": "Resources",
      "searchPlaceholder": "Search resources...",
      "allTypes": "All Types",
      "person": "Person",
      "room": "Room",
      "equipment": "Equipment",
      "vehicle": "Vehicle",
      "english": "English",
      "bulgarian": "Bulgarian",
      "spanish": "Spanish",
      "language": "Language",
      "resourcesCount": "resources",
      "searchTag": "Search: {{text}}",
      "activeFilters": "Active filters",
      "clearAll": "Clear filters"
    },
    "tooltips": {
      "editResource": "Edit Resource",
      "settings": "Settings",
      "deleteResource": "Delete Resource"
    },
    "pagination": "{{start}}-{{end}} of {{total}} resources"
  },
  "serviceResources": {
    "callbackNotApplicableTitle": "Resources are not used for callback requests",
    "callbackNotApplicableDescription": "A callback service collects contact details instead of reserving a time slot, so it does not need roles or linked resources.",
    "sectionTitle": "Roles & linked resources",
    "sectionHelp": "Each role defines what this service needs (e.g. Barber). Link resources that can fill each role.",
    "emptyRoles": "No roles yet. Add a role to define what this service needs and which resources can be booked.",
    "addRole": "Add role",
    "removeRole": "Remove role",
    "removeRoleConfirm": "Remove role \"{{role}}\"? Linked resources for this role will be removed when you save.",
    "role": "Service role",
    "roleRequired": "Select a service role",
    "rolePlaceholder": "Select a role",
    "roleLocked": "Remove linked resources before changing this role.",
    "createRoleOption": "Create a new role",
    "coverageBadge": "{{active}} / {{required}} active",
    "coverageWarning": "Need at least {{required}} active resource(s) for this role.",
    "linkedResources": "Linked resources",
    "noLinksYet": "No resources linked for this role yet.",
    "addResource": "Add resource",
    "addResourcePlaceholder": "Select a resource",
    "linkActive": "Active",
    "removeLink": "Remove",
    "noEligibleResources": "No resources have the \"{{role}}\" role yet. Assign this role when creating or editing a resource.",
    "browseResources": "Browse resources",
    "primaryRoleHint": "Mark exactly one role below as the client choice. Quantity must be 1 for that role.",
    "primaryRoleHintInline": "Client primary selection is enabled — choose one role the client picks at booking.",
    "newRole": "New role",
    "clientChoiceTag": "Client choice",
    "markAsClientChoice": "Client chooses this role",
    "primaryQuantityLocked": "Client choice roles must have quantity 1.",
    "linkedCount": "{{count}} linked",
    "activeServiceCoverageWarning": "This service is live but some roles do not have enough active resources. Booking may fail until you link more resources or deactivate the service.",
    "activeServiceNoRolesWarningTitle": "Live service has no roles",
    "activeServiceNoRolesWarningDescription": "Add at least one role below and save, or turn the service off on the General tab until roles are configured.",
    "saveLinksError": "Failed to save linked resources",
    "unnamedResource": "Unnamed resource"
  },
  "serviceRoles": {
    "manageButton": "Service roles",
    "dialogTitle": "Service roles",
    "dialogDescription": "Roles describe what resources can do (e.g. Barber, Technician). Services and resources connect through these roles.",
    "addRole": "Add Role",
    "addFirstRole": "Create your first role",
    "createTitle": "Add Role",
    "editTitle": "Edit role",
    "createButton": "Create Role",
    "saveButton": "Save changes",
    "editButton": "Edit",
    "deleteButton": "Delete",
    "deleteTitle": "Delete role",
    "deleteConfirm": "Delete role \"{{name}}\"? This cannot be undone.",
    "deleteConflict": "This role is still used by resources or services. Remove those links first.",
    "createSuccess": "Role created",
    "updateSuccess": "Role updated",
    "deleteSuccess": "Role deleted",
    "saveError": "Failed to save role",
    "deleteError": "Failed to delete role",
    "empty": "No service roles yet",
    "form": {
      "key": "Role key",
      "keyRequired": "Role key is required",
      "keyLength": "Key must be 1–128 characters",
      "keyPlaceholder": "e.g. barber, ac_technician",
      "keyEditHint": "Role key cannot be changed after creation",
      "name": "Display name",
      "namePlaceholder": "e.g. Barber, AC Technician",
      "description": "Description",
      "descriptionPlaceholder": "Optional description for your team"
    },
    "table": {
      "key": "Role",
      "description": "Description",
      "usage": "Usage",
      "resources": "{{count}} resources",
      "services": "{{count}} services",
      "actions": "Actions"
    }
  },
  "serviceRoleGuide": {
    "step1": {
      "title": "Define roles",
      "description": "Create roles for what your business offers (e.g. Barber, Technician, Room)."
    },
    "step2": {
      "title": "Tag resources",
      "description": "Assign roles to each bookable resource so services know what they can use."
    },
    "step3": {
      "title": "Connect to service",
      "serviceDescription": "Add roles below and link resources that can fill each role.",
      "resourceDescription": "After saving, link this resource to services on each service's Resources tab."
    },
    "manageRoles": "Manage roles",
    "browseResources": "Browse resources",
    "compactHint": "Assign service roles so this resource can be linked to services."
  },
  "serviceSettings": {
    "loading": "Loading service...",
    "notFound": "Service not found",
    "backToServices": "Back to Services",
    "saveButton": "Save changes",
    "saveSuccess": "Service updated successfully",
    "saveError": "Failed to update service",
    "tabs": {
      "general": "General",
      "availability": "Availability",
      "resources": "Resources"
    }
  },
  "resourceSettings": {
    "loading": "Loading resource...",
    "notFound": "Resource not found",
    "backToResources": "Back to Resources",
    "tabs": {
      "availability": "Availability",
      "exceptions": "Exceptions",
      "calendarsSync": "Calendars Sync",
      "policy": "Policy"
    }
  },
  "calendarSync": {
    "caldav": {
      "discovered": "CalDAV calendars discovered.",
      "discoverError": "CalDAV discovery failed.",
      "connectedQueued": "CalDAV connected. Initial synchronization was queued.",
      "connectedPending": "CalDAV connection saved. Initial synchronization could not be queued; periodic synchronization will retry.",
      "connectError": "Could not connect CalDAV.",
      "credentialsUpdated": "CalDAV credentials updated.",
      "credentialsError": "Could not update credentials.",
      "updateError": "Could not update CalDAV synchronization.",
      "queued": "Synchronization queued.",
      "queueError": "Could not queue CalDAV synchronization.",
      "disconnected": "CalDAV disconnected.",
      "disconnectError": "Could not disconnect CalDAV.",
      "title": "CalDAV synchronization",
      "description": "Choose whether to send appointments, import busy time, or do both.",
      "direction": "Sync direction",
      "push": "Push",
      "pull": "Pull",
      "both": "Both",
      "pushDescription": "Send local appointments to the remote calendar. Other remote events do not block availability.",
      "pullDescription": "Import remote events as availability blockers. No appointments are sent or changed in the remote calendar.",
      "bothDescription": "Send local appointments and import other remote events as availability blockers.",
      "directionImmutable": "Direction is chosen when connecting. To change it, disconnect and reconnect. Previously exported remote events remain.",
      "pullNotice": "Manage external events in the remote calendar. Pull only reads the calendar and does not export or repair appointments.",
      "duplicateWarning": "Do not point an ICS import and CalDAV at the same calendar; duplicate blockers may be created.",
      "serverUrl": "https://cloud.example.com",
      "username": "Username",
      "password": "App password",
      "newPassword": "New app password",
      "discover": "Discover calendars",
      "connect": "Connect",
      "notSynced": "Not synchronized",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "every": "Every",
      "minutes": "min",
      "syncNow": "Sync now",
      "initialPending": "Initial synchronization is pending.",
      "lastSync": "Last sync: {{time}}",
      "replaceCredentials": "Replace credentials",
      "disconnectConfirm": "Disconnect CalDAV? Remote events previously pushed by Smart Assistant will remain in the calendar.",
      "disconnect": "Disconnect",
      "loading": "Loading CalDAV connection…",
      "loadError": "Could not load the CalDAV connection.",
      "retry": "Retry",
      "statusSuccess": "Synchronized",
      "statusPartial": "Partially synchronized",
      "statusFailed": "Synchronization failed",
      "cancel": "Cancel",
      "ownershipNotice": "Manage SA appointments in SA. External edits and deletions are restored during synchronization."
    },
    "heroTitle": "Keep Your Calendars Perfectly in Sync",
    "heroDescription": "Use ICS technology to avoid scheduling conflicts by blocking busy time from external calendars and sharing your SmartAss appointments with external apps.",
    "guides": {
      "googleCalendar": "Google Calendar",
      "appleCalendar": "Apple Calendar (iCloud)",
      "outlook": "Microsoft Outlook"
    },
    "import": {
      "title": "Import to SmartAss",
      "subtitle": "Sync External Calendars with SmartAss",
      "description": "Connect external calendar feeds so SmartAss can block time when you are busy elsewhere.",
      "fullVisibility": "Full Visibility",
      "fullVisibilityHint": "Shows event titles and details from the external calendar.",
      "privacyMode": "Privacy Mode",
      "privacyModeHint": "Blocks time only; event titles and locations are hidden wherever imported events are shown in Smart Assistant.",
      "visibilityUpdated": "Visibility mode updated.",
      "visibilityUpdateError": "Failed to update visibility mode.",
      "colSync": "SYNC",
      "colUrl": "CALENDAR URL",
      "colMode": "MODE",
      "colActions": "ACTIONS",
      "urlPlaceholder": "https://example.com/calendar.ics",
      "add": "Add",
      "delete": "Delete",
      "cancel": "Cancel",
      "deleteConfirm": "Remove this calendar feed and its imported busy times?",
      "invalidUrl": "Please enter a valid http or https calendar URL.",
      "addSuccess": "Calendar feed added and synced.",
      "addSuccessWithDelay": "Calendar feed added and synced. It may take up to a minute for events to appear in the calendar.",
      "addError": "Failed to add calendar feed.",
      "syncUpdated": "Sync setting updated.",
      "syncUpdateError": "Failed to update sync setting.",
      "urlUpdated": "Calendar URL updated.",
      "urlUpdateError": "Failed to update calendar URL.",
      "deleteSuccess": "Calendar feed removed.",
      "deleteError": "Failed to remove calendar feed.",
      "howToTitle": "How to Import Your Calendar",
      "step1": "Copy the ICS subscription URL from your external calendar app.",
      "step2": "Paste the URL into the calendar URL field and click Add.",
      "step3": "Enable sync to keep busy times updated automatically.",
      "step4": "Choose Full Visibility or Privacy Mode; the setting is saved on the feed for all users.",
      "step5": "Wait for the first sync to complete before booking over external busy time.",
      "guidesTitle": "How to Get Your ICS Feed"
    },
    "export": {
      "title": "Export from SmartAss",
      "subtitle": "Share SmartAss Appointments with Your Calendars",
      "description": "Generate a subscription URL so external calendars can show appointments and availability changes from SmartAss.",
      "urlPlaceholder": "ICS feed URL will appear here after activation",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "copy": "Copy URL",
      "download": "Download ICS",
      "activateSuccess": "Export feed activated.",
      "activateError": "Failed to activate export feed.",
      "deactivateSuccess": "Export feed deactivated.",
      "deactivateError": "Failed to deactivate export feed.",
      "copySuccess": "Feed URL copied to clipboard.",
      "copyError": "Could not copy URL to clipboard.",
      "howToTitle": "How to Use the ICS Calendar Feed",
      "step1": "Click Activate to generate your subscription URL.",
      "step2": "Copy the URL and open your external calendar app.",
      "step3": "Add a calendar by URL or subscription (not a one-time import).",
      "step4": "Save the subscription; the external app will refresh periodically.",
      "step5": "Appointments created or updated in SmartAss will appear on the next refresh.",
      "guidesTitle": "Setup Guides"
    }
  },
  "resourceModals": {
    "layout": {
      "classificationTitle": "Type & roles",
      "detailsTitle": "Resource details"
    },
    "create": {
      "title": "Add Resource",
      "description": "Add a new schedulable resource to your company",
      "tabSimple": "Simple",
      "tabAdvanced": "Advanced",
      "createButton": "Create Resource",
      "successMessage": "Resource created with default booking policy and working hours. You can adjust them in resource settings.",
      "errorMessage": "Failed to create resource",
      "translationRequired": "Please add at least one translation",
      "defaultsPreview": {
        "title": "Configured automatically on create",
        "policyTitle": "Booking policy",
        "policySummary": "30 min appointments, 15 min start alignment, book up to 90 days ahead, 24 h cancellation notice, 60 min reschedule notice, no overlapping bookings.",
        "availabilityTitle": "Working hours (Mon–Fri)",
        "availability": {
          "PERSON": "9:00–13:00 and 14:00–18:00 (Friday until 17:00). Weekends closed.",
          "ROOM": "8:00–20:00 (Friday until 18:00). Weekends closed.",
          "EQUIPMENT": "8:00–18:00. Weekends closed.",
          "VEHICLE": "7:00–19:00. Weekends closed."
        },
        "editHint": "You can change policy and hours anytime in resource settings after creation."
      }
    },
    "edit": {
      "title": "Edit Resource",
      "description": "Update resource information and translations",
      "tabSimple": "Simple",
      "tabAdvanced": "Advanced",
      "translationsCount": "({{count}} translations)",
      "manageTranslations": "Manage translations for multiple languages",
      "updateButton": "Update Resource",
      "successMessage": "Resource updated successfully",
      "errorMessage": "Failed to update resource",
      "translationRequired": "Please add at least one translation"
    },
    "delete": {
      "title": "Delete Resource",
      "deleteButton": "Delete",
      "confirmMessage": "Are you sure you want to delete the resource \"{{name}}\"? This action cannot be undone and will also delete all associated policies, availability rules, and exceptions.",
      "successMessage": "Resource deleted successfully",
      "errorMessage": "Failed to delete resource"
    },
    "serviceRoles": {
      "label": "Service roles",
      "placeholder": "Select roles this resource can fill",
      "help": "Roles connect this resource to services. You can manage the role catalog from the Services page."
    },
    "isHidden": {
      "label": "Hide from direct booking",
      "tooltip": "Hidden resources are excluded from the AI agent's resource list and cannot receive standalone appointments. They can still be assigned automatically when a customer books a service that links this resource through a role.",
      "help": "Use for supporting resources (equipment, rooms, assistants) that should only be booked as part of a service.",
      "switchOn": "Hidden",
      "switchOff": "Visible"
    }
  },
  "resourceForm": {
    "resourceName": "Resource Name",
    "resourceNameRequired": "Please enter a resource name",
    "resourceNameTooltip": "Enter the name of the resource as it will appear to users",
    "resourceNamePlaceholder": "e.g., Dr. John Smith, Conference Room A",
    "language": "Language",
    "languageRequired": "Please select a language",
    "languagePlaceholder": "Select language",
    "metadata": "Metadata (JSON)",
    "metadataTooltip": "Optional JSON object for additional data like specialization, license, etc.",
    "metadataHelp": "Example: {\"specialization\": \"Dentist\", \"license\": \"DDS-12345\"}",
    "notificationEmail": "Notification email",
    "notificationEmailTooltip": "Email address used for customer change requests on appointments assigned to this resource",
    "notificationEmailPlaceholder": "e.g., doctor@clinic.example",
    "notificationEmailInvalid": "Please enter a valid email address"
  },
  "availability": {
    "callbackNotApplicableTitle": "Availability is not used for callback requests",
    "callbackNotApplicableDescription": "A callback service does not offer appointment slots. The client provides a preferred callback time as free text.",
    "day": "Day",
    "status": "Status",
    "scheduleMode": "Schedule",
    "editorTitle": "Weekly hours",
    "hoursLegend": "Working hours",
    "legend": {
      "continuous": "Continuous: set Open and Close only (middle columns unused).",
      "split": "Lunch break: all four times define morning, break, and afternoon."
    },
    "weekdays": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    },
    "mode": {
      "closed": "Closed",
      "continuous": "Continuous",
      "split": "Lunch break"
    },
    "split": {
      "open": "Open",
      "lunchStart": "Lunch start",
      "lunchEnd": "Lunch end",
      "close": "Close"
    },
    "noScheduleTitle": "No Availability Schedule Configured",
    "noScheduleDescription": "This resource doesn't have any availability schedule configured yet. Bookings can still be made, but there will be no time restrictions. Set the weekly schedule below and click 'Save Availability Schedule' to restrict bookings to specific days and hours.",
    "weeklyScheduleTitle": "Weekly Schedule",
    "weeklyScheduleDescription": "Choose Closed, Continuous (one block), or Lunch break (morning and afternoon windows). Lunch break saves two availability rules per day, matching split-shift defaults for people resources.",
    "open": "Open",
    "closed": "Closed",
    "start": "Start",
    "end": "End",
    "startTimePlaceholder": "Start time",
    "endTimePlaceholder": "End time",
    "required": "Required",
    "validation": {
      "required": "Please set all times",
      "endAfterStart": "End must be after start",
      "lunchStartAfterOpen": "Lunch start must be after opening",
      "lunchEndAfterLunchStart": "Lunch end must be after lunch start",
      "closeAfterLunchEnd": "Close must be after lunch end"
    },
    "copyMondayToWeekdays": "Copy Monday to Tue–Fri",
    "copyMondaySuccess": "Monday schedule copied to Tuesday through Friday",
    "extraWindowsWarning": "Some days had more than two time windows; only the first two are shown as a lunch break.",
    "saveButton": "Save Availability Schedule",
    "resetButton": "Reset",
    "successMessage": "Availability updated successfully",
    "errorMessage": "Failed to update availability"
  },
  "exceptions": {
    "alertTitle": "Time Exceptions",
    "alertDescription": "Add exceptions for specific dates when the resource is unavailable (holidays, maintenance, special events). Bookings can still be made without exceptions, but adding them will block appointments during those periods.",
    "addTitle": "Add Exception",
    "existingTitle": "Existing Exceptions",
    "unavailablePeriod": "Unavailable Period",
    "unavailablePeriodRequired": "Please select a date and time range",
    "reason": "Reason",
    "reasonOptional": "Reason (Optional)",
    "reasonPlaceholder": "e.g., Holiday, Maintenance, Special Event, etc.",
    "startDateTime": "Start Date & Time",
    "endDateTime": "End Date & Time",
    "addButton": "Add Exception",
    "dateRange": "Date Range",
    "startDate": "Start Date",
    "endDate": "End Date",
    "filterByReason": "Filter by reason...",
    "resetFilters": "Reset Filters",
    "table": {
      "startTime": "Start Time",
      "endTime": "End Time",
      "reason": "Reason",
      "actions": "Actions"
    },
    "today": "Today",
    "noReason": "No reason",
    "removeTitle": "Remove exception",
    "removeConfirm": "Are you sure you want to remove this exception?",
    "removeYes": "Yes",
    "removeNo": "No",
    "removeButton": "Remove",
    "exceptionCount": "{{count}} exception",
    "exceptionCount_plural": "{{count}} exceptions",
    "ofTotal": " of {{total}}",
    "totalExceptions": "Total {{total}} exceptions",
    "noExceptionsFound": "No exceptions found",
    "invalidMetadata": "Invalid JSON in metadata field",
    "addSuccess": "Exception added successfully",
    "addError": "Failed to add exception",
    "removeSuccess": "Exception removed successfully",
    "removeError": "Failed to remove exception"
  },
  "policy": {
    "loadingMessage": "Loading policy settings...",
    "errorTitle": "Error Loading Policy",
    "errorDescription": "Failed to load policy settings. Please refresh the page.",
    "refreshButton": "Refresh",
    "noPolicyTitle": "No Policy Configured",
    "noPolicyDescription": "This resource doesn't have a booking policy yet. Bookings can still be made, but will use default limitations. Configure the settings below and click 'Create Policy Settings' to customize scheduling rules, lead times, buffers, and cancellation policies.",
    "configuredTitle": "Booking Policy Configuration",
    "configuredDescription": "Configure scheduling rules and constraints for this resource. These settings control how appointments can be booked, including time slots, lead times, buffers, and cancellation policies.",
    "slotConfig": {
      "title": "Slot Configuration",
      "description": "Define how time slots are structured",
      "duration": "Slot Duration",
      "durationTooltip": "Length of each appointment slot in minutes. Common values: 15, 30, 45, 60 minutes.",
      "durationRequired": "Slot duration is required",
      "durationMin": "Must be at least 1 minute",
      "durationMax": "Cannot exceed 1440 minutes (24 hours)",
      "alignment": "Slot Alignment",
      "alignmentTooltip": "Time slots will align to intervals of this duration (e.g., 15 minutes = 9:00, 9:15, 9:30...). Should be a divisor of slot duration.",
      "alignmentRequired": "Slot alignment is required",
      "alignmentMin": "Must be at least 1 minute"
    },
    "leadTime": {
      "title": "Lead Time Requirements",
      "description": "Control how far in advance appointments can be booked",
      "minLabel": "Minimum Lead Time",
      "minTooltip": "Minimum time in advance that appointments can be booked (minutes, hours, or days). Set to 0 to allow same-day bookings.",
      "minRequired": "Minimum lead time is required",
      "maxLabel": "Maximum Lead Time",
      "maxTooltip": "Maximum days in advance that appointments can be booked. Prevents booking too far in the future.",
      "maxRequired": "Maximum lead time is required",
      "maxMin": "Must be at least 1 day"
    },
    "buffer": {
      "title": "Buffer Times",
      "description": "Add time gaps between appointments",
      "beforeLabel": "Buffer Before Appointment",
      "beforeTooltip": "Time buffer required before each appointment starts. Useful for preparation time.",
      "beforeRequired": "Buffer before is required",
      "afterLabel": "Buffer After Appointment",
      "afterTooltip": "Time buffer required after each appointment ends. Useful for cleanup or travel time.",
      "afterRequired": "Buffer after is required"
    },
    "cancellation": {
      "title": "Cancellation & Rescheduling",
      "description": "Set restrictions for changes and cancellations",
      "cancelLabel": "Cancellation Lead Time",
      "cancelTooltip": "Minimum time before the appointment when cancellation is allowed (minutes, hours, or days). Set to 0 to allow cancellations anytime.",
      "cancelRequired": "Cancellation lead time is required",
      "rescheduleLabel": "Reschedule Lead Time",
      "rescheduleTooltip": "Minimum time before the appointment when rescheduling is allowed (minutes, hours, or days). Set to 0 to allow rescheduling anytime.",
      "rescheduleRequired": "Reschedule lead time is required"
    },
    "advanced": {
      "title": "Advanced Settings",
      "description": "Additional configuration options",
      "allowOverlaps": "Allow Overlapping Appointments",
      "allowOverlapsTooltip": "Enable if multiple appointments can be scheduled at the same time. Useful for group sessions or resources that can handle multiple bookings simultaneously.",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "validityPeriod": "Validity Period (Optional)",
      "validityPeriodNotice": "If you set a validity period, free slots will only be returned for this resource within that date range. Outside the period, no free slots will be available.",
      "effectiveFrom": "Effective From",
      "effectiveFromTooltip": "When this policy becomes active. Leave empty to start immediately.",
      "effectiveFromPlaceholder": "Select start date",
      "effectiveTo": "Effective To",
      "effectiveToTooltip": "When this policy expires. Leave empty for no expiration.",
      "effectiveToPlaceholder": "Select end date"
    },
    "cannotBeNegative": "Cannot be negative",
    "durationMax": "Cannot exceed one year",
    "minutes": "minutes",
    "hours": "hours",
    "days": "days",
    "updateButton": "Update Policy Settings",
    "createButton": "Create Policy Settings",
    "resetButton": "Reset to Defaults",
    "updateSuccess": "Policy updated successfully",
    "createSuccess": "Policy created successfully",
    "updateError": "Failed to update policy. Please try again.",
    "resetMessage": "Form reset to default values"
  },
  "companyModal": {
    "editTitle": "Edit Company",
    "addTitle": "Add Company",
    "saveButton": "Save Changes",
    "createButton": "Create Company",
    "companyName": "Company Name",
    "companyNameRequired": "Please enter a company name",
    "companyNamePlaceholder": "Acme HQ",
    "companyDomain": "Company Domain",
    "companyDomainTooltip": "Optional domain, e.g. acme.com",
    "companyDomainPlaceholder": "acme.com",
    "street": "Street",
    "streetPlaceholder": "123 Main St",
    "zip": "ZIP / Postal Code",
    "zipPlaceholder": "10001",
    "city": "City",
    "cityPlaceholder": "New York",
    "country": "Country",
    "countryPlaceholder": "US",
    "phone": "Phone",
    "phonePlaceholder": "+1 555 0100",
    "mobile": "Mobile",
    "mobilePlaceholder": "+1 555 0101",
    "fax": "Fax",
    "faxPlaceholder": "+1 555 0102",
    "email": "Email",
    "emailPlaceholder": "info@acme.com",
    "directions": "Directions",
    "directionsPlaceholder": "How to find this company / office (optional)",
    "addDescription": "Add a new location or branch with its address and contact details",
    "emailInvalid": "Please enter a valid email address",
    "sections": {
      "address": "Address",
      "contact": "Contact"
    }
  },
  "resourceTypeSelector": {
    "label": "Resource Type",
    "required": "Please select a resource type",
    "placeholder": "Select resource type",
    "person": "Person",
    "room": "Room",
    "equipment": "Equipment",
    "vehicle": "Vehicle"
  },
  "timezoneSelector": {
    "label": "Timezone",
    "required": "Please select a timezone",
    "tooltip": "Select the timezone where this resource is located",
    "placeholder": "Search timezone..."
  },
  "reminders": {
    "title": "Reminders",
    "description": "View and manage reminders for you and your team.",
    "loadError": "Failed to load reminders",
    "tryAgain": "Try Again",
    "newReminder": "Add Reminder",
    "stats": {
      "total": "Total",
      "active": "Active",
      "notified": "Notified",
      "overdue": "Overdue",
      "done": "Done"
    },
    "filters": {
      "searchPlaceholder": "Search by title or note...",
      "statusPlaceholder": "All statuses",
      "refresh": "Refresh",
      "clearAll": "Clear All",
      "activeFilters": "Active filters:",
      "searchTag": "Search: \"{{text}}\"",
      "statusTag": "Status: {{status}}",
      "remindersCount": "{{filtered}} / {{total}} reminders"
    },
    "view": {
      "all": "All",
      "active": "Active",
      "notified": "Notified",
      "overdue": "Overdue",
      "done": "Done"
    },
    "status": {
      "active": "Active",
      "notified": "Notified",
      "overdue": "Overdue",
      "done": "Done",
      "cancelled": "Cancelled"
    },
    "audience": {
      "TENANT": "Tenant",
      "USER": "User"
    },
    "modal": {
      "title": "Add Reminder",
      "description": "Schedule a follow-up for yourself or your team.",
      "titleLabel": "Title",
      "titlePlaceholder": "What do you need to remember?",
      "titleRequired": "Title is required",
      "dueLabel": "Due date and time",
      "dueRequired": "Due date is required",
      "dueFuture": "Due date must be in the future",
      "notifyLeadLabel": "Notify before due",
      "notifyLeadRequired": "Please select when to be notified",
      "notifyLeadWhenDue": "When due",
      "notifyLeadMinutesBefore": "{{count}} minutes before",
      "notifyLeadHoursBefore_one": "{{count}} hour before",
      "notifyLeadHoursBefore_other": "{{count}} hours before",
      "notifyLeadDefaultHint": "Your default is {{minutes}} minutes before due",
      "levelLabel": "Level",
      "levelUser": "User",
      "levelTenant": "Tenant",
      "levelUserHint": "Visible to assignee and tenant owner",
      "levelTenantHint": "Visible to everyone in your organization",
      "assigneeLabel": "Assign to",
      "assigneePlaceholder": "Select team member",
      "assigneeRequired": "Please select who this reminder is for",
      "noteLabel": "Note",
      "notePlaceholder": "Optional details...",
      "save": "Create Reminder",
      "cancel": "Cancel",
      "success": "Reminder created successfully",
      "error": "Failed to create reminder"
    },
    "layout": {
      "table": "Table",
      "calendar": "Calendar",
      "legend": "Status",
      "moreOnDay": "+{{count}} more"
    },
    "detail": {
      "title": "Reminder details",
      "type": "Type"
    },
    "table": {
      "title": "All Reminders",
      "reminder": "Reminder",
      "due": "Due",
      "type": "Type",
      "note": "Note",
      "status": "Status",
      "actions": "Actions",
      "markDone": "Mark done",
      "markDoneConfirmTitle": "Mark reminder as done?",
      "markDoneConfirmDescription": "\"{{title}}\" will be marked as completed.",
      "markDoneConfirmOk": "Mark done",
      "markDoneConfirmCancel": "Cancel",
      "loading": "Loading reminders...",
      "reminderCount": "{{count}} reminder",
      "reminderCount_plural": "{{count}} reminders",
      "showingRange": "Showing {{start}}-{{end}} of {{total}} reminders",
      "noMatchFilters": "No reminders match your filter criteria",
      "noRemindersFound": "No reminders yet",
      "noRemindersHint": "Create a reminder to track important follow-ups.",
      "clearFilters": "Clear Filters",
      "noNote": "No note",
      "automaticTag": "Automatic"
    },
    "bell": {
      "allCaughtUp": "You're all caught up",
      "needsAttention_one": "{{count}} needs attention",
      "needsAttention_other": "{{count}} need attention",
      "overdueCount_one": "{{count}} overdue",
      "overdueCount_other": "{{count}} overdue",
      "noActiveReminders": "No active reminders",
      "newRemindersAppearHere": "New reminders will appear here",
      "dueSoon": "Due soon",
      "viewAllReminders": "View all reminders"
    }
  },
  "translationList": {
    "title": "Translations",
    "defaultExtraText": "Add translations for multiple languages",
    "selectLanguage": "Select language",
    "languagePlaceholder": "Language",
    "enterName": "Enter name",
    "namePlaceholder": "Resource name in this language",
    "addTranslation": "Add Translation"
  },
  "bulkActions": {
    "selected": "{{count}} selected",
    "clearSelection": "Clear selection"
  },
  "deleteEntity": {
    "title": {
      "threads": "Permanently delete {{count}} thread?",
      "threads_plural": "Permanently delete {{count}} threads?",
      "leads": "Permanently delete {{count}} lead?",
      "leads_plural": "Permanently delete {{count}} leads?",
      "customers": "Permanently delete {{count}} customer?",
      "customers_plural": "Permanently delete {{count}} customers?"
    },
    "confirm": "Delete permanently",
    "delete": "Delete",
    "deleteTooltip": "Delete permanently",
    "deleteSelected": "Delete ({{count}})",
    "willRemove": "The following will be permanently removed:",
    "nothingFound": "Nothing left to delete.",
    "irreversible": "This cannot be undone. Deleted items are removed everywhere and no longer count in statistics. No email or SMS is sent.",
    "previewError": "Could not determine what would be deleted. Nothing was changed.",
    "success": "{{count}} item(s) deleted",
    "partial": "Deleted {{deleted}} of {{total}}. The rest can be retried.",
    "error": "Delete failed. Nothing was changed.",
    "failedItems": "These items could not be deleted:",
    "counts": {
      "customers": "{{count}} customer",
      "customers_plural": "{{count}} customers",
      "leads": "{{count}} lead",
      "leads_plural": "{{count}} leads",
      "threads": "{{count}} thread",
      "threads_plural": "{{count}} threads",
      "messages": "{{count}} message",
      "messages_plural": "{{count}} messages",
      "emails": "{{count}} email",
      "emails_plural": "{{count}} emails",
      "appointments": "{{count}} appointment",
      "appointments_plural": "{{count}} appointments",
      "memberships": "{{count}} customer portal access",
      "memberships_plural": "{{count}} customer portal accesses"
    }
  }
}
